export class DatosTasaBancoldex {
  constructor(
    public idModalidad: Number,
    public idDestino: Number,
    public idIntermediario: String,
    public plazoTasa: Number
  ) {}
}